import { utilsModule } from "../utils-module";

utilsModule.factory('OrderTypeService',[function(){

	var self = this;

	function OrderTypeClass(type,_OrderTypeService){

	  var OrderTypeService = _OrderTypeService;

	  this.type = type;

	  this.getName = function(){
	  	return OrderTypeService.getName(this.type);
	  }

	  this.getPluralName = function(){
	  	return OrderTypeService.getPluralName(this.type);
	  }

	  this.getOrderTypeId = function(){
	  	return OrderTypeService.getOrderTypeId(this.type);
	  }

	  this.getQtdFieldName = function(){
	  	return OrderTypeService.getQtdFieldName(this.type);
	  }

	  this.getStartRoute = function(){
	  	return OrderTypeService.getStartRoute(this.type);
	  }

	  this.getOrderTypeObj = function(){
	  	return OrderTypeService.getOrderTypeObj(this.type);
	  }

	  this.isBudget = function(){
	  	return OrderTypeService.isBudget(this.type);
	  }

	  this.getTheme = function(){
	  	return OrderTypeService.getTheme(this.type);
	  }
	}


	this.orderTypes = {
	  	'SALES'    : {
			name:{
				singular:'SALE',
				plural:'SALES'
			},
			verb:'SELL',
			orderTypeId: 3, 
			startRoute: 'sales',
			qtdeFieldName: 'qtVenda',
			theme: 'saleTheme'
		},
	  	'SHOPPING' : {
	  		name:{
	  			singular:'PURCHASE', 
	  			plural:'PURCHASES'
	  		}, 
	  		verb:'PURCHASE',
	  		orderTypeId: 4,
	  		startRoute: 'shopping',
	  		qtdeFieldName: 'qtCompra',
	  		theme: 'purchaseTheme'
	  	},
	  	'STOCK' : {
	  		name:{
	  			singular:'STOCK_ORDER', 
	  			plural:'STOCK_ORDERS'
	  		}, 
	  		verb:'STOCK',
	  		orderTypeId: 5,
	  		startRoute: 'stock',
	  		qtdeFieldName: 'qtEstoque',
	  		theme: 'stockTheme'
	  	},
	  	'BUDGET' : {
	  		name:{
	  			singular:'BUDGET', 
	  			plural:'BUDGETS'
	  		}, 
	  		verb:'BUDGET',
	  		orderTypeId: 1,
	  		startRoute: 'budget',
	  		qtdeFieldName: 'qtPedido',
	  		theme: 'budgetTheme'
	  	},
	  	'BUDGET-ADD' : {
	  		name:{
	  			singular:'BUDGET', 
	  			plural:'BUDGETS'
	  		}, 
	  		verb:'BUDGET',
	  		orderTypeId: 2,
	  		startRoute: 'budget',
	  		qtdeFieldName: 'qtVenda',
	  		theme: 'budgetTheme'
	  	},
		'PACKAGE' : {
			name:{
				singular:'PACKAGE_MOVIMENTATION', 
				plural:'PACKAGE_MOVIMENTATIONS'
			}, 
			verb:'PACKAGE',
			orderTypeId: 9,
			startRoute: 'package',
			qtdeFieldName: 'qtPedido',
			theme: 'packageTheme'
		},


		/**
		 * OUTROS MODULOS: Não correspondem a tipos de pedido
		 */


		'TAGS' : {
			name:{
				singular:'TAG', 
				plural:'TAGS'
			}, 
			verb:'TO_TAG',
			startRoute: 'tags-home',
			/*
			@TODO: provisoriamente utiliza o mesmo tema para os dois modulos
			*/
			theme: 'saleTheme'
		},
		'PACKING' : {
			name:{
				singular:'PACKING', 
				plural:'PACKING'
			}, 
			verb:'PACKING',
			startRoute: 'packing-home',
			/*
			@TODO: provisoriamente utiliza o mesmo tema para os dois modulos
			*/
			theme: 'saleTheme'
		},
		'MENU' : {
			name:{
				singular:'MENU', 
				plural:'MENU'
			}, 
			verb:'MENU',
			startRoute: 'modules-menu',
			/*
			@TODO: provisoriamente utiliza o mesmo tema para os dois modulos
			*/
			theme: 'saleTheme'
		}
	};

	return {

		ORDER_TYPE_SALES      : self.orderTypes['SALES'].orderTypeId,
		ORDER_TYPE_PURCHASE   : self.orderTypes['SHOPPING'].orderTypeId,
		ORDER_TYPE_STOCK      : self.orderTypes['STOCK'].orderTypeId,
		ORDER_TYPE_BUDGET     : self.orderTypes['BUDGET'].orderTypeId,
		ORDER_TYPE_BUDGET_ADD : self.orderTypes['BUDGET-ADD'].orderTypeId,
		ORDER_TYPE_PACKAGE    : self.orderTypes['PACKAGE'].orderTypeId,


		getOrderTypeList : function(){
			return self.orderTypes;
		},

		getTypeByRoutName : function(routName){
			for (var i in self.orderTypes){
				var orderType = self.orderTypes[i];
				if (orderType.startRoute == routName){
					return i;
				}
			}
			return undefined;
		},		

		getTypeByOrderTypeId : function(orderTypeId){
			for (var i in self.orderTypes){
				var orderType = self.orderTypes[i];
				if (orderType.orderTypeId == orderTypeId){
					return i;
				}
			}
			return undefined;
		},

		getName : function(type){
		  	var ordeType = self.orderTypes[type];
		  	if (!ordeType) return null;
		  	return ordeType.name.singular;
		},

		getOrderTypeObj : function(type){
			return self.orderTypes[type];
		},

		getPluralName : function(type){
		  	var ordeType = self.orderTypes[type];
		  	if (!ordeType) return null;
		  	return ordeType.name.plural;
		},

		getOrderTypeId : function(type){
		  	var ordeType = self.orderTypes[type];
		  	if (!ordeType) return null;
		  	return ordeType.orderTypeId;
		},

		getQtdFieldName : function(type){		  	
		  	if (typeof type == "string"){
				var ordeType = self.orderTypes[type];
			  	if (!ordeType) return null;
			  	return ordeType.qtdeFieldName;
			}else{
				var typeStr = this.getTypeByOrderTypeId(type);
				var ordeType = self.orderTypes[typeStr];
			  	if (!ordeType) return null;
			  	return ordeType.qtdeFieldName;
			}
		},

		getStartRoute : function(type){
			var ordeType = self.orderTypes[type];
		  	if (!ordeType) return null;
		  	return ordeType.startRoute;	
		},


		isBudget : function(type){
			if (typeof type == "string"){
				type = self.orderTypes[type].orderTypeId;
			}
			
			return (type == this.ORDER_TYPE_BUDGET) || (type == this.ORDER_TYPE_BUDGET_ADD);
		},

		getTheme : function(type){
			var ordeType = self.orderTypes[type];
		  	if (!ordeType) return null;
		  	return ordeType.theme;	
		},

		createOrderTypeInstance : function(type){
			if (typeof type == "string"){
				return new OrderTypeClass(type,this);
			}else{
				var typeStr = this.getTypeByOrderTypeId(type);
				return new OrderTypeClass(typeStr,this);
			}
		}

	}


}]);